module.exports = __webpack_public_path__ + "static/media/football.38cde7af.jpg";